import React, { Component } from 'react';
import Home from './HomeComponent';
import Auto from './AutoComponent';
import Management from './ManagementComponent';
import Keto from './KetoComponent';
import Adventure from './AdventureComponent';
import Finance from './FinanceComponent';
import DishDetail from './DishdetailComponent';
import Monthly from './MonthlyComponent';
import Header from './HeaderComponent';
import Footer from './FooterComponent';
import ScrollToTop from './ScrollToTop';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { 
  postComment, postMonth, postAuto, postAdventure,
  fetchDishes, fetchMonths, fetchAutos, 
  fetchComments, fetchFinances, fetchAdventures, fetchCards, 
  loginUser, logoutUser, googleLogin 
} from '../redux/ActionCreators';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

// Map state to props
const mapStateToProps = state => ({
  dishes: state.dishes,
  months: state.months,
  autos: state.autos,
  comments: state.comments,
  finances: state.finances,
  adventures: state.adventures,
  cards: state.cards,
  auth: state.auth
});

// Map dispatch to props
const mapDispatchToProps = dispatch => ({
  postMonth: (payOne, payTwo, emergencyFund, investmentFund, mortgage, water, housingGas, electricity, cable, trash, autoGas, autoMaintenance, groceries, restaurants, phone, clothing, householdItems, funMoney, subscriptions, partnerCare, childCare, gym, medicine, doctorVisits, healthInsurance, autoInsurance, homeInsurance, debt, giving) => dispatch(postMonth(payOne, payTwo, emergencyFund, investmentFund, mortgage, water, housingGas, electricity, cable, trash, autoGas, autoMaintenance, groceries, restaurants, phone, clothing, householdItems, funMoney, subscriptions, partnerCare, childCare, gym, medicine, doctorVisits, healthInsurance, autoInsurance, homeInsurance, debt, giving)),
  postAuto: (km, fifteen, thirty, fourtyfive, seventyfive, ninety, passcode) => dispatch(postAuto(km, fifteen, thirty, fourtyfive, seventyfive, ninety, passcode)),
  postAdventure: (name, description, createdAt, yearSelection, image) => dispatch(postAdventure(name, description, createdAt, yearSelection, image)),
  postComment: (dishId, rating, comment) => dispatch(postComment(dishId, rating, comment)),
  fetchDishes: () => dispatch(fetchDishes()),
  fetchMonths: () => dispatch(fetchMonths()),
  fetchAutos: () => dispatch(fetchAutos()),
  fetchComments: () => dispatch(fetchComments()),
  fetchFinances: () => dispatch(fetchFinances()),
  fetchAdventures: () => dispatch(fetchAdventures()),
  fetchCards: () => dispatch(fetchCards()),
  loginUser: creds => dispatch(loginUser(creds)),
  logoutUser: () => dispatch(logoutUser()),
  googleLogin: () => dispatch(googleLogin())
});

class Main extends Component {

  componentDidMount() {
    this.props.fetchDishes();
    this.props.fetchMonths();
    this.props.fetchAutos();
    this.props.fetchComments();
    this.props.fetchFinances();
    this.props.fetchAdventures();
    this.props.fetchCards();
  }

  componentWillUnmount() {
    // Optionally, handle any cleanup if necessary
  }

  render() {
    const HomePage = () => (
      <Home 
        management={this.props.finances.finances.find(finance => finance.managementFilter)}
        financesLoading={this.props.finances.isLoading}
        financesErrMess={this.props.finances.errMess}
        auto={this.props.cards.cards.find(card => card.autoFilter)}
        cardsLoading={this.props.cards.isLoading}
        cardsErrMess={this.props.cards.errMess}
        dish={this.props.cards.cards.find(card => card.dishFilter)}
      />
    );

    const FinancePage = () => (
      <Finance 
        monthly={this.props.finances.finances.find(finance => finance.monthFilter)}
        financesLoading={this.props.finances.isLoading}
        financesErrMess={this.props.finances.errMess}
        management={this.props.finances.finances.find(finance => finance.managementFilter)}
      />
    );

    const MonthlyPage = () => (
      <Monthly 
        months={this.props.months.months}
        monthsErrMess={this.props.months.errMess}
        postMonth={this.props.postMonth}
      />
    );

    const ManagementPage = () => (
      <Management 
        management={this.props.finances.finances.find(finance => finance.planningImageFilter)}
        financesLoading={this.props.finances.isLoading}
        financesErrMess={this.props.finances.errMess}
        baby={this.props.finances.finances.find(finance => finance.babyImageFilter)}
        investment={this.props.finances.finances.find(finance => finance.investmentImageFilter)}
        other={this.props.finances.finances.find(finance => finance.otherImageFilter)}
      />
    );

    const AutoPage = () => (
      <Auto 
        kmFifteen={this.props.autos.autos.find(auto => auto.fifteen)}
        autosErrMess={this.props.autos.errMess}
        postAuto={this.props.postAuto}
        kmThirty={this.props.autos.autos.find(auto => auto.thirty)}
        kmFourtyfive={this.props.autos.autos.find(auto => auto.fourtyfive)}
        kmSeventyfive={this.props.autos.autos.find(auto => auto.seventyfive)}
        kmNinety={this.props.autos.autos.find(auto => auto.ninety)}
      />
    );

    const DishWithId = ({ match }) => (
      <DishDetail 
        dish={this.props.dishes.dishes.find(dish => dish._id === match.params.dishId)}
        isLoading={this.props.dishes.isLoading}
        errMess={this.props.dishes.errMess}
        comments={this.props.comments.comments.filter(comment => comment.dish === match.params.dishId)}
        commentsErrMess={this.props.comments.errMess}
        postComment={this.props.postComment}
      />
    );

    const AdventurePage = () => (
      <Adventure 
        adventuresLoading={this.props.adventures.isLoading}
        adventuresErrMess={this.props.adventures.errMess}
        a2023={this.props.adventures.adventures.filter(adventure => adventure.a2023)}
        a2024={this.props.adventures.adventures.filter(adventure => adventure.a2024)}
        a2025={this.props.adventures.adventures.filter(adventure => adventure.a2025)}
        postAdventure={this.props.postAdventure}
      />
    );

    const PrivateRoute = ({ component: Component, ...rest }) => (
      <Route {...rest} render={(props) => (
        this.props.auth.isAuthenticated
          ? <Component {...props} />
          : <Redirect to={{
              pathname: '/home',
              state: { from: props.location }
            }} />
      )} />
    );

    return (
      <div>
        <Header 
          auth={this.props.auth}
          loginUser={this.props.loginUser}
          logoutUser={this.props.logoutUser}
          googleLogin={this.props.googleLogin}
        />
        <TransitionGroup>
          <CSSTransition key={this.props.location.key} classNames="page" timeout={300}>
            <ScrollToTop>
              <Switch>
                <Route path="/home" component={HomePage} />
                <PrivateRoute exact path="/finance" component={FinancePage} />
                <PrivateRoute exact path="/finance/monthly" component={MonthlyPage} />
                <PrivateRoute exact path='/finance/management' component={ManagementPage} />
                <PrivateRoute exact path='/auto' component={AutoPage} />
                <PrivateRoute exact path='/adventure' component={AdventurePage} />
                <Route exact path="/keto" component={() => <Keto dishes={this.props.dishes} />} />
                <Route path="/keto/:dishId" component={DishWithId} />
                <Redirect to="/home" />
              </Switch>
            </ScrollToTop>
          </CSSTransition>
        </TransitionGroup>
        <Footer />
      </div>
    );
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Main));



// WEBPACK FOOTER //
// ./src/components/MainComponent.js